<div *ngIf="showSpinner" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
<div *ngFor="let publications_of_type of publicationsData | keyvalue" class="publications_list_by_type_container">
  <h1>{{ publications_types.get(publications_of_type.key) ?? 'unknown publication type' }}</h1>
  <ol class="publications_list_by_type" reversed>
    <div *ngFor="let year of publications_of_type.value.years_array">
      <h2>{{ year}}</h2>
      <li *ngFor="let value of publications_of_type.value.entries.get(year.toString())" [innerHTML]="value"></li>
    </div>
  </ol>
</div>
